<template>
    <div class="action-item" @click="$store.state.core.featuresStatus.highlight_links = !$store.state.core.featuresStatus.highlight_links" :class="{active: $store.state.core.featuresStatus.highlight_links}">
        <div class="active-action item" v-if="$store.state.core.featuresStatus.highlight_links">
          <span class="icon-check"></span>
        </div>


        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                    <div v-html="icons.highlightedLinks"></div>
                    <h3>{{$t('highlight links')}}</h3>
                </div>
            </template>
            <span>{{$t('highlight links')}}</span>
        </v-tooltip>

        <v-style v-if="$store.state.core.featuresStatus.highlight_links">
            a {
                color: #E4E400 !important;
                background: black !important;
            }
        </v-style>
    </div>
</template>

<script>
    import {icons} from '../../utils/icons'
    export default {
        name: "links",
        data() {
            return {
                linkColored: false,
                icons
            }
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        watch: {
            '$store.state.core.featuresStatus.highlight_links':function (state) {
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
                if (state) {
                    this.$emit('countAnalytics', this.data._id)
                }
            }
        }
    }
</script>

<style scoped>

</style>
